// extracted by mini-css-extract-plugin
export var pillWrapper = "_xr-0";
export var showOverflow = "_xr-1";